export interface AppIntegration {
  id: string;
  appId: string;
  providerId: string;
  name: string;
  config: Record<string, unknown>;
  status: 'active' | 'inactive' | 'error' | 'pending';
  isDefault: boolean;
  capabilities: string[];
  providerName: string;
  lastSyncAt?: string;
  syncInterval?: number;
  lastError?: string;
  createdAt: string;
  updatedAt: string;
}

export interface ConfigField {
  type: 'string' | 'number' | 'boolean';
  required: boolean;
  description: string;
  default?: unknown;
  /**
   * Rótulo pronto, em português, vindo do provider. Sem ele, o formulário
   * deriva o rótulo do nome do campo — que é inglês e técnico.
   */
  label?: string;
  enum?: string[];
  enumLabels?: Record<string, string>;
}

export interface ProviderDefinition {
  id: string;
  name: string;
  capabilities: string[];
  categories: string[];
  status: string;
  configSchema: Record<string, ConfigField | unknown>;
}

export interface IntegrationsListResponse {
  items: AppIntegration[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export type IntegrationStatus = 'active' | 'inactive' | 'error' | 'pending';

export const STATUS_LABELS: Record<IntegrationStatus, string> = {
  active: 'Ativo',
  inactive: 'Inativo',
  error: 'Erro',
  pending: 'Pendente',
};

export const STATUS_VARIANTS: Record<IntegrationStatus, 'success' | 'error' | 'warning' | 'info'> = {
  active: 'success',
  inactive: 'error',
  error: 'warning',
  pending: 'info',
};

export const CATEGORY_LABELS: Record<string, string> = {
  messaging: 'Mensageria',
  marketing: 'Marketing',
  payment: 'Pagamento',
  calendar: 'Calendario',
  ai: 'Inteligencia Artificial',
  database: 'Banco de Dados',
  webhook: 'Webhook',
  push: 'Push',
  meta: 'Meta',
  geo: 'Geolocalizacao',
};
